import axios from '../axios';
import { TEAM_SIGNUP_BRANCH } from '../ApiUrl';

/**
 * POST /TeamSignupBranch
 * Creates a new branch team member with role & route-access settings.
 *
 * @param {Object} payload
 * @param {string} payload.email
 * @param {string} payload.firstName
 * @param {string} payload.lastName
 * @param {string} payload.phone_no          - exactly 10 digits
 * @param {string} payload.password          - min 5 characters
 * @param {string} payload.branchName
 * @param {string} payload.team_user_id
 * @param {string} [payload.manual_notes]
 * @param {string} [payload.dedicatedRole]   - marketing | sales | hr | superadmin | none
 * @param {string} [payload.user_type]       - team_member | regional_branch
 * @param {Array}  [payload.routeAccess]     - [{ route, access: { read, write, edit, delete }, is_active }]
 */
export const teamSignupBranchAPI = async (payload) => {
  try {
    const response = await axios.post(TEAM_SIGNUP_BRANCH, payload);
    return response;
  } catch (error) {
    console.log('teamSignupBranchAPI catch', error);
    return { hasError: true, error };
  }
};
